export default "__VITE_ASSET__BYOCCNAJ__"